import axios from 'axios';

const getFarmerFeedback = (farmerId) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/api/farmer/feedback/${farmerId}`)
    .then((res) => res)
    .catch((err) => err);
};

export default getFarmerFeedback;
